export type Lead = {
  id: number;
  source: string | null;
  name: string | null;
  leadStatus: LeadConnectionStatus;
  tagsClosed: TagsClosed;
  qualifyDate: string | null;
  richText: string;
};

export enum LeadsState {
  unhandled = 'Unhandled',
  active = 'Active',
  handled = 'Handled'
}

export type LeadItems = {
  totalCount: number;
  items: LeadItem[];
};

export type LeadItem = {
  id: number;
  source: string;
  name: string;
  city: string;
  type: string | null;
  qualifyDate: string | null;
  leadStatus: LeadConnectionStatus;
  tagsClosed: TagsClosed;
};

export type LeadConnectionStatus = {
  type: LeadConnectionStatusTypeEnum;
  text: string | null;
};

export type TagsClosed = {
  type: TagsClosedEnum;
  text: string | null;
};

export type ModalType = 'delete' | 'active' | 'handled' | 'unhandled';

export type LeadStatus = 'hasContacted' | 'hasStarted' | 'noContact';

export enum LeadConnectionStatusTypeEnum {
  sentToReseller = 'SentToReseller',
  newTryWithCustomer = 'NewTryWithCustomer',
  customerNotReachable = 'CustomerNotReachable',
  customerContact = 'CustomerContact',
  closed = 'Closed'
}

export type LeadCompletionAction = 'customerBought' | 'customerNotDecided' | 'customerNotBought' | 'none';

export enum TagsClosedEnum {
  Deal = 'Deal',
  Unsure = 'Unsure',
  NoDeal = 'NoDeal',
  None = 'None'
}
